import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./features.css";

const FeatureData = [
  {
    title: "Quick Learning",
    desc: "We value your time. Our courses are designed for quick, effective learning. Dive into your chosen subject matter and acquire valuable skills in a shorter time frame. Get ahead in your career with our focused and efficient learning approach.!",
    icon: "ri-draft-line",
  },

  {
    title: "Certification",
    desc: "We take pride in providing high-quality certification programs. Our certificates are a testament to your commitment to learning and personal development. They serve as a validation of your skills and knowledge in your chosen field.",
    icon: "ri-discuss-line",
  },

  {
    title: "Projects",
    desc: "Our projects are designed to challenge and inspire you. Engage in hands-on experiences that mirror real-world scenarios. From coding challenges to creative endeavors, our projects will help you build practical skills and grow as a professional.!",
    icon: "ri-contacts-book-line",
  },
];

const Features = () => {
  return (
    <section>
      <Container>
        <Row>
          {FeatureData.map((item, index) => (
            <Col lg="4" md="6" key={index}>
              <div className="single__feature text-center px-4">
                <h2 className="mb-3">
                  <i class={item.icon}></i>
                </h2>
                <h6>{item.title}</h6>
                <p>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
